import React, { useEffect, useState } from 'react'
import { Box, Button, ButtonGroup, Card, CardContent, CardMedia, Fade, FormControl, FormHelperText, Grid, Input, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material"
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { useNavigate } from 'react-router'
import { getSlugsAsync, selectSlugLoading, selectSlugs } from '../slugs/SlugSlice'
import { Link, ArrowUpward, ArrowDownward } from '@mui/icons-material'
import { Masonry } from '@mui/lab'
import { selectAuthUser } from '../auth/AuthSlice'
import { selectDomainCss } from '../analysis/AnalysisSlice'

export interface SlugTableProps {
  mode: 'all' | 'my' | 'myDomain' | 'byEmail' | 'byEmailDomain',
  arg?: string
}

const SlugTable = (props: SlugTableProps) => {

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const slugs = useAppSelector(selectSlugs)
  const loading = useAppSelector(selectSlugLoading)
  const [filter, setFilter] = useState('')
  const [sort, setSort] = useState('createdTime,desc')
  const [size, setSize] = useState(50)
  const [page, setPage] = useState(0)
  const authUser = useAppSelector(selectAuthUser)
  const domainCss = useAppSelector(selectDomainCss)
  useEffect(() => {
    if (authUser) {
      dispatch(getSlugsAsync({ page: { page, size, sort }, mode: props.mode, arg: props.arg ? props.arg : '' }))
    }
  }, [authUser])

  return (slugs && slugs.totalElements && slugs.totalElements > 0) ? <Box>
    {props.mode === 'my' && <Grid container spacing={2}>
      {slugs.content.filter((slug, index) => index < 10)
        .map((slug: any, index: number) => <Grid item xs={12} sm={6} md={4} key={index}>
          <Card>
            <CardMedia component="img" image={slug.img && slug.img.length > 10 ? slug.img : '/images/v2/no-image.png'} onError={(e: any) => { e.target.src = '/images/v2/no-image.png' }}
              sx={{ cursor: 'pointer', maxHeight: '250px' }} onClick={() => navigate({ pathname: `/analysis/slug/${slug.slug}` })} />
            <CardContent>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <Typography variant="body2">
                  {slug.address}
                </Typography>
                <Typography variant="caption" sx={{ color: domainCss?.instructionColor }}>
                  {slug.createdTime?.substring(0, 10)}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>)}
    </Grid>
    }
    {(slugs.totalElements > 10 || props.mode !== 'my') && <>
      <Input placeholder="Filter" value={filter} onChange={(e) => setFilter(e.target.value)} />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="Recent search table">
          <TableHead>
            <TableRow>
              {props.mode === 'all' || 'myDomain' && <TableCell><Button disabled={loading} onClick={() => {
                var tmp = ''
                if (sort.startsWith('userEmail') && sort.endsWith('desc')) {
                  tmp = 'userEmail,asc'
                } else {
                  tmp = 'userEmail,desc'
                }
                setSort(tmp)
                dispatch(getSlugsAsync({ page: { page, size, sort: tmp }, mode: props.mode, arg: props.arg ? props.arg : '' }))
              }}>Email
                {sort.startsWith('userEmail') ? sort === 'userEmail,desc' ? <ArrowDownward onClick={() => setSort('userEmail,asc')} /> : <ArrowUpward onClick={() => setSort('userEmail,desc')} /> : <></>}
              </Button></TableCell>}
              <TableCell><Button disabled={loading} onClick={() => {
                var tmp = ''
                if (sort.startsWith('address') && sort.endsWith('desc')) {
                  tmp = 'address,asc'
                } else {
                  tmp = 'address,desc'
                }
                setSort(tmp)
                dispatch(getSlugsAsync({ page: { page, size, sort: tmp }, mode: props.mode, arg: props.arg ? props.arg : '' }))
              }}>Address
                {sort.startsWith('address') ? sort === 'address,desc' ? <ArrowDownward onClick={() => setSort('address,asc')} /> : <ArrowUpward onClick={() => setSort('address,desc')} /> : <></>}
              </Button></TableCell>
              <TableCell><Button disabled={loading} onClick={() => {
                var tmp = ''
                if (sort.startsWith('createdTime') && sort.endsWith('desc')) {
                  tmp = 'createdTime,asc'
                } else {
                  tmp = 'createdTime,desc'
                }
                setSort(tmp)
                dispatch(getSlugsAsync({ page: { page, size, sort: tmp }, mode: props.mode, arg: props.arg ? props.arg : '' }))
              }}>Generated
                {sort.startsWith('createdTime') ? sort === 'createdTime,desc' ? <ArrowDownward onClick={() => setSort('createdTime,asc')} /> : <ArrowUpward onClick={() => setSort('createdTime,desc')} /> : <></>}
              </Button></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {slugs.content.filter((slug, index) => (filter.length == 0
              || slug.userEmail?.toLowerCase().indexOf(filter.toLowerCase()) > -1
              || slug.address?.toLowerCase().indexOf(filter.toLowerCase()) > -1)
              && (index > 9 || props.mode !== 'my'))
              .map((slug: any, index: number) => <TableRow key={`${slug.id}-${index}`}>
                {props.mode === 'all' || 'myDomain' && <TableCell>
                  {slug.userEmail}
                </TableCell>}
                <TableCell>
                  {slug.address}
                </TableCell>
                <TableCell>
                  {slug.createdTime?.substring(0, 10)}
                </TableCell>
                <TableCell>
                  <Button disabled={slug.role === 'ROLE_ADMIN'} onClick={() => navigate({ pathname: `/analysis/slug/${slug.slug}` })}>
                    <Link /></Button>
                </TableCell>
              </TableRow>)}
          </TableBody>
        </Table>
        <TablePagination
          backIconButtonProps={loading ? { disabled: true } : {}}
          nextIconButtonProps={loading ? { disabled: true } : {}}
          rowsPerPageOptions={[25, 50, 100, 250, 500]}
          component="div"
          count={slugs.totalElements}
          page={slugs.number}
          onPageChange={(event, newPage) => {
            setPage(newPage)
            dispatch(getSlugsAsync({ page: { page: newPage, size, sort }, mode: props.mode, arg: props.arg ? props.arg : '' }))
          }}
          rowsPerPage={slugs.size}
          onRowsPerPageChange={(event) => {
            setSize(parseInt(event.target.value))
            dispatch(getSlugsAsync({ page: { page: 0, size: parseInt(event.target.value), sort }, mode: props.mode, arg: props.arg ? props.arg : '' }))
          }}
        />
      </TableContainer>
    </>}
  </Box> : <></>
}

export default SlugTable